import React from 'react';
import { Tag, Size, ArtistOption } from '../../types';
import './GalleryFilters.css';

interface GalleryFiltersProps {
  tags: Tag[];
  availableSizes: Size[];
  artists: ArtistOption[];
  selectedTags: number[];
  selectedSize: string;
  selectedArtist: string;
  selectedArtistTier: string;
  onTagToggle: (tagId: number) => void;
  onSizeChange: (value: string) => void;
  onArtistChange: (value: string) => void;
  onArtistTierChange: (value: string) => void;
}

const GalleryFilters: React.FC<GalleryFiltersProps> = ({
  tags,
  availableSizes,
  artists,
  selectedTags,
  selectedSize,
  selectedArtist,
  selectedArtistTier,
  onTagToggle,
  onSizeChange,
  onArtistChange,
  onArtistTierChange
}) => {
  return (
    <div className="gallery-filters-horizontal">
      <div className="filters-row">
        <div className="filter-item">
          <span className="filter-label">Tags</span>
          <div className="tags-list-horizontal">
            {tags.length > 0 ? (
              tags.map((tag) => (
                <button
                  key={tag.id}
                  className={`tag-button ${selectedTags.includes(tag.id) ? 'active' : ''}`}
                  onClick={() => onTagToggle(tag.id)}
                >
                  {tag.name}
                </button>
              ))
            ) : (
              <span className="no-tags">No tags available</span>
            )}
          </div>
        </div>

        <div className="filter-item">
          <label className="filter-label" htmlFor="gallery-filter-size">Size</label>
          <select
            id="gallery-filter-size"
            value={selectedSize}
            onChange={(e) => onSizeChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All Sizes</option>
            {availableSizes.map(size => (
              <option key={size.id} value={size.name}>{size.name}</option>
            ))}
          </select>
        </div>

        <div className="filter-item">
          <label className="filter-label" htmlFor="gallery-filter-artist">Artist</label>
          <select
            id="gallery-filter-artist"
            value={selectedArtist}
            onChange={(e) => onArtistChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All Artists</option>
            {artists.map((artist, index) => {
              const name = artist.artistName || 'Unknown Artist';
              const value = artist.artistId ? `id:${artist.artistId}` : `name:${name}`;
              return (
                <option key={`${value}-${index}`} value={value}>
                  {name}
                </option>
              );
            })}
          </select>
        </div>

        <div className="filter-item">
          <label className="filter-label" htmlFor="gallery-filter-artist-tier">Artist level</label>
          <select
            id="gallery-filter-artist-tier"
            value={selectedArtistTier}
            onChange={(e) => onArtistTierChange(e.target.value)}
            className="filter-select"
          >
            <option value="">All levels</option>
            <option value="Up & Coming">Up &amp; Coming</option>
            <option value="Emerging">Emerging</option>
            <option value="Established">Established</option>
            <option value="Acclaimed">Acclaimed</option>
            <option value="Master">Master</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default GalleryFilters;
